enum MentionType {
  USER = "user",
  TEAM = "team",
}

export default MentionType;
